function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Group-6"
}, React.createElement("rect", {
  id: "Rectangle-Copy-4",
  stroke: "#636363",
  x: 0.5,
  y: 0.5,
  width: 45.1454545,
  height: 39,
  rx: 4
}), React.createElement("g", {
  id: "Group",
  transform: "translate(13.282609, 10.434783)",
  fill: "#636363",
  fillRule: "nonzero",
  stroke: "#F4F7FC",
  strokeWidth: 0.2
}, React.createElement("path", {
  d: "M15.5815217,0.0795956044 C13.4745168,0.0795956044 11.75,1.56338901 11.75,3.3762989 C11.75,3.69656703 11.8094141,4.00327033 11.9096467,4.29662857 L6.20226304,7.38728791 C5.54870761,6.94174505 4.72495598,6.6730022 3.83152174,6.6730022 C1.72451685,6.6730022 0,8.1567956 0,9.96971429 C0,11.7826154 1.72451685,13.2664176 3.83152174,13.2664176 C4.72894076,13.2664176 5.55529783,12.9943736 6.21025815,12.5452527 L11.9096467,15.6359121 C11.8080092,15.9311429 11.75,16.2405495 11.75,16.5631209 C11.75,18.376022 13.4745168,19.8598242 15.5815217,19.8598242 C17.6885266,19.8598242 19.4130435,18.376022 19.4130435,16.5631209 C19.4130435,14.7501978 17.6885266,13.2664176 15.5815217,13.2664176 C14.3963299,13.2664176 13.3323418,13.7348791 12.6280571,14.4683297 L7.20806304,11.5287692 C7.50076576,11.0636703 7.66304348,10.532989 7.66304348,9.96971429 C7.66304348,9.40536264 7.49379239,8.87635165 7.20006793,8.41063736 C8.99477826,7.42716703 10.8193234,6.44832527 12.6280571,5.47107912 C13.3323418,6.20453407 14.3963299,6.6730022 15.5815217,6.6730022 C17.6885266,6.6730022 19.4130435,5.18920879 19.4130435,3.3762989 C19.4130435,1.56338901 17.6885266,0.0795956044 15.5815217,0.0795956044 Z M15.5815217,1.39827692 C16.8602538,1.39827692 17.8804348,2.27605714 17.8804348,3.3762989 C17.8804348,4.47654066 16.8602538,5.35432088 15.5815217,5.35432088 C14.3027897,5.35432088 13.2826087,4.47654066 13.2826087,3.3762989 C13.2826087,2.27605714 14.3027897,1.39827692 15.5815217,1.39827692 Z M3.83152174,7.99168352 C5.1102538,7.99168352 6.13043478,8.86947253 6.13043478,9.96971429 C6.13043478,11.069956 5.1102538,11.9477363 3.83152174,11.9477363 C2.55278967,11.9477363 1.5326087,11.069956 1.5326087,9.96971429 C1.5326087,8.86947253 2.55278967,7.99168352 3.83152174,7.99168352 Z M15.5815217,14.5850989 C16.8602538,14.5850989 17.8804348,15.4628791 17.8804348,16.5631209 C17.8804348,17.6633626 16.8602538,18.5411429 15.5815217,18.5411429 C14.3027897,18.5411429 13.2826087,17.6633626 13.2826087,16.5631209 C13.2826087,15.4628791 14.3027897,14.5850989 15.5815217,14.5850989 Z",
  id: "Shape"
}))));

const SvgShareIconBordered = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "47px",
    height: "40px",
    viewBox: "0 0 47 40",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgShareIconBordered, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share_icon_bordered.339763e4.svg";
export { ForwardRef as ReactComponent };